module.exports = __webpack_public_path__ + "assets/img/questionAnswering.4773b520.png";